/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchRunResultPaymentGroupsInnerTotals
 */
export interface BatchRunResultPaymentGroupsInnerTotals {
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultPaymentGroupsInnerTotals
     */
    subtotalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultPaymentGroupsInnerTotals
     */
    serviceFee: number;
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultPaymentGroupsInnerTotals
     */
    totalPayoutAmount: number;
}

/**
 * Check if a given object implements the BatchRunResultPaymentGroupsInnerTotals interface.
 */
export function instanceOfBatchRunResultPaymentGroupsInnerTotals(value: object): value is BatchRunResultPaymentGroupsInnerTotals {
    if (!('subtotalAmount' in value) || value['subtotalAmount'] === undefined) return false;
    if (!('serviceFee' in value) || value['serviceFee'] === undefined) return false;
    if (!('totalPayoutAmount' in value) || value['totalPayoutAmount'] === undefined) return false;
    return true;
}

export function BatchRunResultPaymentGroupsInnerTotalsFromJSON(json: any): BatchRunResultPaymentGroupsInnerTotals {
    return BatchRunResultPaymentGroupsInnerTotalsFromJSONTyped(json, false);
}

export function BatchRunResultPaymentGroupsInnerTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultPaymentGroupsInnerTotals {
    if (json == null) {
        return json;
    }
    return {
        
        'subtotalAmount': json['subtotal_amount'],
        'serviceFee': json['service_fee'],
        'totalPayoutAmount': json['total_payout_amount'],
    };
}

export function BatchRunResultPaymentGroupsInnerTotalsToJSON(json: any): BatchRunResultPaymentGroupsInnerTotals {
    return BatchRunResultPaymentGroupsInnerTotalsToJSONTyped(json, false);
}

export function BatchRunResultPaymentGroupsInnerTotalsToJSONTyped(value?: BatchRunResultPaymentGroupsInnerTotals | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subtotal_amount': value['subtotalAmount'],
        'service_fee': value['serviceFee'],
        'total_payout_amount': value['totalPayoutAmount'],
    };
}

